define([
    "./extensionModule",
    "./nlgExtension",
    "./extensionService"
], function () {
});